module.exports = __webpack_public_path__ + "img/34.61c99d50.jpg";